import { queryOptions, skipToken } from "@tanstack/react-query";
import { shouldRetryQuery } from "@softmax/web-features/data";
import { unwrapReadResult } from "@/lib/read-result";
import { isRouteAccessDenied } from "@/session/route-query";
import {
  getGameContext,
  getGameIndex,
  getGameWikiCount,
} from "./game.functions";
import { gameResourceHref } from "./game-types";

export function gameContextQueryOptions(href: string) {
  const resource = gameResourceHref(href);
  return queryOptions({
    queryKey: ["game-context", resource],
    queryFn: async ({ signal }) =>
      unwrapReadResult(
        await getGameContext({ data: { href: resource }, signal }),
      ),
    retry: (count, error: Error) =>
      !isRouteAccessDenied(error) && shouldRetryQuery(count, error),
    throwOnError: isRouteAccessDenied,
    staleTime: 60_000,
  });
}

export function gameIndexQueryOptions(href: string) {
  const resource = gameResourceHref(href);
  return queryOptions({
    queryKey: ["game-index", resource],
    queryFn: async ({ signal }) =>
      unwrapReadResult(
        await getGameIndex({ data: { href: resource }, signal }),
      ),
    retry: (count, error: Error) =>
      !isRouteAccessDenied(error) && shouldRetryQuery(count, error),
    throwOnError: isRouteAccessDenied,
    staleTime: 60_000,
  });
}

export function gameWikiQueryOptions(coworldName: string | null) {
  return queryOptions({
    queryKey: ["public", "game-wiki-count", coworldName],
    queryFn: coworldName
      ? ({ signal }) => getGameWikiCount({ data: { coworldName }, signal })
      : skipToken,
    staleTime: 60_000,
    throwOnError: isRouteAccessDenied,
  });
}
